import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { TableLoader } from '../../../../../../components/Table/TableLoader';
import { PageHeading } from '../../../../components';

export function AccessRoleAssignmentLoader(): ReactElement {
  const { t } = useTranslation();

  return (
    <section className="half-padding-left">
      <PageHeading text={t('accessRoleAssignment.name')} />
      <TableLoader />
    </section>
  );
}
